import { render } from "./user-edit.vue?vue&type=template&id=475505e1"
import script from "./user-edit.vue?vue&type=script&lang=js"
export * from "./user-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__